export default "__VITE_ASSET__C29_64BV__"